import { useEffect, useMemo } from "react"
import { defaultAppTitle } from "src/common/defaultAppTitle"

interface AppTitleProps {
	locationCode: string | undefined
	title?: string
}

export const AppTitle = ({ locationCode, title }: AppTitleProps) => {
	const baseTitle = useMemo(
		() => (locationCode ? `${locationCode} | ${defaultAppTitle}` : defaultAppTitle),
		[locationCode],
	)

	useEffect(() => {
		const newTitle = title ? `${title} | ${baseTitle}` : baseTitle
		if (newTitle !== document.title) {
			document.title = newTitle
		}

		return () => {
			// reset to default, otherwise old title would persist during routing or loading until newly set
			document.title = baseTitle
		}
	}, [baseTitle, title])

	return null
}
